<template>
    <div style="padding: 1rem 1.5rem">
        <div>
            <p>Dear [Client],</p>
            <p>At Sims Investment Management, LLC, we take great pride in our tradition of delivering exceptional customer service and support. Enclosed with this email, you will find a copy of our firm's Privacy Policy, which we are required to provide to you annually. We take the protection of your personal information very seriously. Please take a moment to review it, and let us know if you have any questions about how we safeguard your non-public information.</p>
            <p>Also included with this letter are copies of our firm's Form ADV Part 2A, ADV 2B and Form CRS. These documents provide a comprehensive overview of our firm and highlight key disclosures you should be aware of. Copies were originally provided when your account was opened.</p>
            <p>At Sims Investment Management, LLC, we truly value your relationship and are committed to offering investment solutions tailored to your unique needs. As a Managing Member, it is my responsibility to keep you informed of any material changes to our firm. Thank you for the opportunity to serve you. As always, please feel free to contact me with any questions.</p>
            <p>
                Sincerely,<br>
                Cory K. Sims<br>
                Managing Member
            </p>
        </div>
    </div>
</template>

<script>
export default {
}
</script>